import React from 'react';
import { Grid, Button, Box } from '@mui/material';

const Audio = ({ data, onClickFinalizar }) => {
    const audio = data?.audio;

    const finalizar = () => {
        onClickFinalizar({
            tipo: data.tipo,
            idDetalleActividad: data.idDetalleActividad,
            idColaborador: data.idColaborador,
            idActividad: data.idActividad,
            idTemario: data.idTemario,
            idSesion: data.idSesion,
            idCurso: data.idCurso
        });
    };

    if (!audio?.linkVideo && !audio?.linkAudio) return null;

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box
                    sx={{
                        backgroundColor: '#003764', // azul marino
                        borderRadius: '12px',
                        padding: '16px',
                        boxShadow: '0px 4px 10px rgba(0,0,0,0.3)'
                    }}
                >
                    <audio
                        controls
                        style={{
                            width: '100%',
                            accentColor: '#d4af37'
                        }}
                    >
                        <source src={audio?.linkAudio || audio?.linkVideo} type="audio/mpeg" />
                        <track kind="captions" />
                        Tu navegador no soporta audio.
                    </audio>
                </Box>
            </Grid>

            <Grid item xs={12} display="flex" justifyContent="end">
                <Button variant="contained" sx={{ backgroundColor: '#003764', color: '#FFFFFF', borderRadius: '0px' }} onClick={finalizar}>
                    Terminado
                </Button>
            </Grid>
        </Grid>
    );
};

export default Audio;
